// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1bzUx","footer":"ChangeClinic_footer__32aVo"};